import { Component, Input } from '@angular/core';
import { AnyObject, ChartOptions, StatisticsPanelConfig } from '@mri/types';
import { dataToChatOptions } from '@mri/functions';

@Component({
  selector: 'app-statistics-panel',
  templateUrl: './statistics-panel.component.html',
  styleUrl: './statistics-panel.component.scss'
})
export class StatisticsPanelComponent {
  private _config?: StatisticsPanelConfig;
  private _data?: Array<AnyObject>;

  chartOptions: Partial<ChartOptions>;
  colors = [
    "#FF5733", // Red-Orange
    "#33FF57", // Green
    "#3357FF", // Blue
    "#FFFF33", // Yellow
    "#FF33FF", // Magenta
    "#33FFFF", // Cyan
    "#FF9900", // Orange
    "#66FF33", // Lime Green
    "#3366FF", // Indigo
    "#FF3366", // Pink
    "#99FF33", // Light Green
    "#6633FF", // Violet
    "#FF33CC", // Hot Pink
    "#33FF99", // Mint Green
    "#FF6633", // Coral
    "#3399FF", // Sky Blue
    "#FF3399", // Raspberry
    "#33CCFF", // Light Blue
    "#FF9933", // Dark Orange
    "#33FF66", // Spring Green
    "#FF6633", // Tomato
    "#3399FF", // Dodger Blue
    "#FF33FF", // Fuchsia
    "#33FFFF", // Turquoise
    "#FF66FF", // Light Pink
  ];


  @Input() set data (value:  Array<AnyObject>){
    this._data = value;
    this._executeRender();
  }

  @Input() set config (config: StatisticsPanelConfig){
    this._config = config;
    this._executeRender();
  }

  @Input() set configNative (config: Partial<ChartOptions>){
    this.chartOptions = config;
    this.chartOptions.colors = this.colors;
    //this._executeRender();
  }


  private _executeRender(){
    const config = this._config;
    if(!config) return;

    const data = this._data;
    if(!data) return;

    if(config.type === 'line')
      this.chartOptions = dataToChatOptions(data, config);

    if(config.type === 'circle')
      this.chartOptions = dataToChatOptions(data, config);

    console.log('this.chartOptions ', this.chartOptions );
  }
}
